var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "global-address-administration__edit" }, [
    _vm.validationFailed
      ? _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12 col-md-6 col-lg-4" }, [
            _c("div", { staticClass: "error-general" }, [
              _c("p", { staticClass: "error-general__label" }, [
                _vm._v(_vm._s(_vm.$t("errors.general.headline"))),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "error-general__message" }, [
                _vm._v(_vm._s(_vm.validationFailed)),
              ]),
            ]),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12 col-md-6 col-lg-4" }, [
        _c(
          "div",
          {
            staticClass: "form-group",
            class: _vm.validationCountry ? "has-fe-error" : "",
          },
          [
            _c(
              "label",
              {
                staticClass: "form__label",
                attrs: { for: "alternate-address--country" },
              },
              [_vm._v(_vm._s(_vm.$t("labels.addressFields.country")))]
            ),
            _vm._v(" "),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.affectedAddress.country,
                    expression: "affectedAddress.country",
                  },
                ],
                staticClass: "form__select",
                attrs: { id: "alternate-address--country" },
                on: {
                  select: function ($event) {
                    return _vm.$emit(
                      "update:affectedAddress",
                      _vm.affectedAddress
                    )
                  },
                  change: function ($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function (o) {
                        return o.selected
                      })
                      .map(function (o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.$set(
                      _vm.affectedAddress,
                      "country",
                      $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                    )
                  },
                },
              },
              [
                _c(
                  "option",
                  { attrs: { disabled: "", selected: "", value: "" } },
                  [_vm._v(_vm._s(_vm.$t("labels.choose")))]
                ),
                _vm._v(" "),
                _vm._l(_vm.countries, function (country, key) {
                  return [
                    _c("option", { domProps: { value: key } }, [
                      _vm._v(_vm._s(country)),
                    ]),
                  ]
                }),
              ],
              2
            ),
            _vm._v(" "),
            _vm.validationCountry
              ? _c("div", { staticClass: "form__error" }, [
                  _c("span", { staticClass: "form__fe-error" }, [
                    _vm._v(_vm._s(_vm.validationCountry)),
                  ]),
                  _c("span", { staticClass: "form__be-error" }),
                ])
              : _vm._e(),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c(
            "label",
            {
              staticClass: "form__label",
              attrs: { for: "alternate-address--company" },
            },
            [_vm._v(_vm._s(_vm.$t("labels.addressFields.company")))]
          ),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.affectedAddress.company,
                expression: "affectedAddress.company",
              },
            ],
            staticClass: "form__input form__input--text",
            attrs: { id: "alternate-address--company", type: "text" },
            domProps: { value: _vm.affectedAddress.company },
            on: {
              change: function ($event) {
                return _vm.$emit("update:affectedAddress", _vm.affectedAddress)
              },
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.affectedAddress, "company", $event.target.value)
              },
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "form__error" }, [
            _c("span", { staticClass: "form__fe-error" }, [
              _vm._v(_vm._s(_vm.errors.street)),
            ]),
            _c("span", { staticClass: "form__be-error" }),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "form-group",
            class: _vm.validationFirstName ? "has-fe-error" : "",
          },
          [
            _c(
              "label",
              {
                staticClass: "form__label",
                attrs: { for: "alternate-address--first-name" },
              },
              [_vm._v(_vm._s(_vm.$t("labels.addressFields.firstName")))]
            ),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.affectedAddress.firstName,
                  expression: "affectedAddress.firstName",
                },
              ],
              staticClass: "form__input form__input--text",
              attrs: { id: "alternate-address--first-name", type: "text" },
              domProps: { value: _vm.affectedAddress.firstName },
              on: {
                change: function ($event) {
                  return _vm.$emit(
                    "update:affectedAddress",
                    _vm.affectedAddress
                  )
                },
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(
                    _vm.affectedAddress,
                    "firstName",
                    $event.target.value
                  )
                },
              },
            }),
            _vm._v(" "),
            _vm.validationFirstName
              ? _c("div", { staticClass: "form__error" }, [
                  _c("span", { staticClass: "form__fe-error" }, [
                    _vm._v(_vm._s(_vm.validationFirstName)),
                  ]),
                  _c("span", { staticClass: "form__be-error" }),
                ])
              : _vm._e(),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "form-group",
            class: _vm.validationLastName ? "has-fe-error" : "",
          },
          [
            _c(
              "label",
              {
                staticClass: "form__label",
                attrs: { for: "alternate-address--last-name" },
              },
              [_vm._v(_vm._s(_vm.$t("labels.addressFields.lastName")))]
            ),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.affectedAddress.lastName,
                  expression: "affectedAddress.lastName",
                },
              ],
              staticClass: "form__input form__input--text",
              attrs: { id: "alternate-address--last-name", type: "text" },
              domProps: { value: _vm.affectedAddress.lastName },
              on: {
                change: function ($event) {
                  return _vm.$emit(
                    "update:affectedAddress",
                    _vm.affectedAddress
                  )
                },
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.affectedAddress, "lastName", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _vm.validationLastName
              ? _c("div", { staticClass: "form__error" }, [
                  _c("span", { staticClass: "form__fe-error" }, [
                    _vm._v(_vm._s(_vm.validationLastName)),
                  ]),
                  _c("span", { staticClass: "form__be-error" }),
                ])
              : _vm._e(),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-12 col-md-6 col-lg-4" }, [
        _c(
          "div",
          {
            staticClass: "form-group",
            class: _vm.validationStreet ? "has-fe-error" : "",
          },
          [
            _c(
              "label",
              {
                staticClass: "form__label",
                attrs: { for: "alternate-address--street" },
              },
              [_vm._v(_vm._s(_vm.$t("labels.addressFields.street")))]
            ),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.affectedAddress.street,
                  expression: "affectedAddress.street",
                },
              ],
              staticClass: "form__input form__input--text",
              attrs: { id: "alternate-address--street", type: "text" },
              domProps: { value: _vm.affectedAddress.street },
              on: {
                change: function ($event) {
                  return _vm.$emit(
                    "update:affectedAddress",
                    _vm.affectedAddress
                  )
                },
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.affectedAddress, "street", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _vm.validationStreet
              ? _c("div", { staticClass: "form__error" }, [
                  _c("span", { staticClass: "form__fe-error" }, [
                    _vm._v(_vm._s(_vm.validationStreet)),
                  ]),
                  _c("span", { staticClass: "form__be-error" }),
                ])
              : _vm._e(),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "form-group",
            class: _vm.validationPostCode ? "has-fe-error" : "",
          },
          [
            _c(
              "label",
              {
                staticClass: "form__label",
                attrs: { for: "alternate-address--postcode" },
              },
              [_vm._v(_vm._s(_vm.$t("labels.addressFields.postCode")))]
            ),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.affectedAddress.postCode,
                  expression: "affectedAddress.postCode",
                },
              ],
              staticClass: "form__input form__input--text",
              attrs: { id: "alternate-address--postcode", type: "text" },
              domProps: { value: _vm.affectedAddress.postCode },
              on: {
                change: function ($event) {
                  return _vm.$emit(
                    "update:affectedAddress",
                    _vm.affectedAddress
                  )
                },
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.affectedAddress, "postCode", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _vm.validationPostCode
              ? _c("div", { staticClass: "form__error" }, [
                  _c("span", { staticClass: "form__fe-error" }, [
                    _vm._v(_vm._s(_vm.validationPostCode)),
                  ]),
                  _c("span", { staticClass: "form__be-error" }),
                ])
              : _vm._e(),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "form-group",
            class: _vm.validationCity ? "has-fe-error" : "",
          },
          [
            _c(
              "label",
              {
                staticClass: "form__label",
                attrs: { for: "alternate-address--city" },
              },
              [_vm._v(_vm._s(_vm.$t("labels.addressFields.city")))]
            ),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.affectedAddress.city,
                  expression: "affectedAddress.city",
                },
              ],
              staticClass: "form__input form__input--text",
              attrs: { id: "alternate-address--city", type: "text" },
              domProps: { value: _vm.affectedAddress.city },
              on: {
                change: function ($event) {
                  return _vm.$emit(
                    "update:affectedAddress",
                    _vm.affectedAddress
                  )
                },
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.affectedAddress, "city", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _vm.validationCity
              ? _c("div", { staticClass: "form__error" }, [
                  _c("span", { staticClass: "form__fe-error" }, [
                    _vm._v(_vm._s(_vm.validationCity)),
                  ]),
                  _c("span", { staticClass: "form__be-error" }),
                ])
              : _vm._e(),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "form-group",
            class: _vm.validationPhone ? "has-fe-error" : "",
          },
          [
            _c(
              "label",
              {
                staticClass: "form__label",
                attrs: { for: "alternate-address--phone" },
              },
              [_vm._v(_vm._s(_vm.$t("labels.addressFields.phone")))]
            ),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.affectedAddress.phone,
                  expression: "affectedAddress.phone",
                },
              ],
              staticClass: "form__input form__input--text",
              attrs: { id: "alternate-address--phone", type: "text" },
              domProps: { value: _vm.affectedAddress.phone },
              on: {
                change: function ($event) {
                  return _vm.$emit(
                    "update:affectedAddress",
                    _vm.affectedAddress
                  )
                },
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.affectedAddress, "phone", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _vm.validationPhone
              ? _c("div", { staticClass: "form__error" }, [
                  _c("span", { staticClass: "form__fe-error" }, [
                    _vm._v(_vm._s(_vm.validationPhone)),
                  ]),
                  _c("span", { staticClass: "form__be-error" }),
                ])
              : _vm._e(),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }